import axiosInstance from './axiosConfig';

const inventoryService = {
  getAll: async () => {
    const response = await axiosInstance.get('/inventories');
    return Array.isArray(response.data) ? response.data : response.data.data;
  },
  
  getById: async (id) => {
    const response = await axiosInstance.get(`/inventories/${id}`);
    return response.data;
  },
getByState: async (state) => {
  const response = await axiosInstance.get(`/inventories/${state}`);
  return response.data;
},

 getActive: async () => {
  const response = await axiosInstance.get("/inventories/active");
  return response.data.data.map(inv => ({
    value: inv.id,
    text: inv.name,
  }));
},


  create: async (data) => {
    const response = await axiosInstance.post('/inventories/add', data);
    return response.data;
  },
  
  update: async (id, data) => {
    const response = await axiosInstance.put(`/inventories/edit/${id}`, data);
    return response.data;
  },
  
  delete: async (id) => {
    const response = await axiosInstance.delete(`/inventories/delete/${id}`);
    return response.data;
  },
  
  filter: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.type) params.append('type', filters.type);
    if (filters.search) params.append('search', filters.search);
    
    const response = await axiosInstance.get(
      params.toString()
        ? `/inventories?${params.toString()}`
        : '/inventories'
    );
    return response.data;
  },
};

export default inventoryService;
